
import React from 'react';
import { PenTool, Users, DollarSign } from 'lucide-react';

const HowItWorks = () => {
  const steps = [
    {
      icon: <PenTool className="h-10 w-10 text-directpress-orange" />,
      title: "Journalists Publish Directly",
      description: "Writers create and publish their stories without editorial oversight, maintaining complete creative control."
    },
    {
      icon: <Users className="h-10 w-10 text-directpress-orange" />,
      title: "Readers Subscribe",
      description: "Readers can subscribe to individual journalists they trust or the entire platform for a diverse news diet."
    },
    {
      icon: <DollarSign className="h-10 w-10 text-directpress-orange" />,
      title: "Direct Monetization",
      description: "Subscription fees go directly to journalists, creating a sustainable model for independent journalism."
    }
  ];

  return (
    <section id="how-it-works" className="py-16 md:py-24 bg-gray-50">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-directpress-blue mb-4">How DirectPress Works</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Our platform creates a direct connection between journalists and readers, removing unnecessary middlemen.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div 
              key={index} 
              className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 flex flex-col items-center text-center"
            >
              <div className="bg-directpress-blue/5 p-4 rounded-full mb-6">
                {step.icon}
              </div>
              <h3 className="text-xl font-semibold text-directpress-blue mb-3">{step.title}</h3>
              <p className="text-gray-600">{step.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 p-8 bg-directpress-blue rounded-xl text-white text-center">
          <h3 className="text-2xl font-semibold mb-4">A New Era of Journalism</h3>
          <p className="mb-6 max-w-3xl mx-auto">
            DirectPress removes the barriers between journalists and their audience, creating a more transparent, 
            independent, and sustainable model for news.
          </p>
          <div className="flex flex-wrap justify-center gap-2">
            <span className="px-4 py-2 bg-white/10 rounded-full">No Gatekeepers</span>
            <span className="px-4 py-2 bg-white/10 rounded-full">Direct Revenue</span>
            <span className="px-4 py-2 bg-white/10 rounded-full">Authentic Voices</span>
            <span className="px-4 py-2 bg-white/10 rounded-full">Reader Ownership</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
